// frontend/src/App.js
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import LoginPage from './pages/LoginPage';
import DashBoard from './pages/DashBoard';
import QuizPage from './pages/QuizPage';
import PricingPage from './pages/PricingPage';
import SuccessPage from './pages/SuccessPage';
 
function PrivateRoute({ children }) {
  const { user } = useAuth();
  return user ? children : <Navigate to='/login' />;
}
 
export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path='/login' element={<LoginPage />} />
          <Route path='/pricing' element={<PricingPage />} />
          <Route path='/success' element={<SuccessPage />} />
          <Route path='/' element={<PrivateRoute><DashBoard /></PrivateRoute>} />
          <Route path='/quiz/:section' element={<PrivateRoute><QuizPage /></PrivateRoute>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
